// src/repos/youtubeRepo.js
import { db } from '@/db/db';

export const youtubeRepo = {
  // 오늘자 캐시 조회
  async listByDate(dayStr) {
    return db.youtube.filter(row => row.update_date === dayStr).toArray();
  },

  // 오늘자(category) 데이터만 교체 (지우고 새로 넣기)
  async replaceYoutube(rows) {
    return db.transaction('rw', db.youtube, async () => {
      await db.youtube.clear();                              // ← 카테고리+오늘자만 삭제

      await db.youtube.bulkPut(rows);             // ← 한 번에 저장
    });
  },
};
